import { Component, Input, OnInit, input, viewChild } from '@angular/core';

import {
  ApexAxisChartSeries,
  ApexTitleSubtitle,
  ApexDataLabels,
  ApexChart,
  ApexPlotOptions,
  ChartComponent,
  NgApexchartsModule,
  ChartType,
} from 'ng-apexcharts';
import { JkBaseComponent } from 'jk-service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  title: ApexTitleSubtitle;
  plotOptions: ApexPlotOptions;
};

@Component({
  selector: 'app-jkheatmap',
  standalone: true,
  imports: [NgApexchartsModule],
  templateUrl: './jkheatmap.component.html',
  styleUrl: './jkheatmap.component.css',
})
export class JkheatmapComponent extends JkBaseComponent implements OnInit {
  readonly chart = viewChild.required<ChartComponent>('chart');
  public chartOptions!: ChartOptions; // Partial<ChartOptions>;
  readonly height = input<number>(350);
  readonly type = input<ChartType>('treemap');
  _itemList: any[] = [];
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() get itemList(): any[] {
    return this._itemList;
  }
  set itemList(value: any[]) {
    this._itemList = value;
  }
  _groupList: string[] = [];
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() get groupList(): string[] {
    return this._groupList;
  }
  set groupList(value: string[]) {
    this._groupList = value;
    //this.getData(this._groupList,this.date);
  }
  _item: string = '';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() get item(): string{
    return this._item;
  }
  set item(value: string){
    this._item = value;
    this.getItemList(value,this.date);
    if(this.date === '') return;
    this.setChartOptions();
  }
  _date:string = '';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() get date(): string{
    return this._date;
  };
  set date(value: string){
    this._date = value;
    this.getItemList(this.item,value);
    if(this.item === '') return;
    this.setChartOptions();
  }
  // _label removed (was overriding JkBaseComponent._label which no longer exists); default label is set in constructor
  readonly ranges = input<any[]>([
    {
        from: 0,
        to: 10,
        name: '漲',
        color: "#CD363A", // 紅色 "#CD363A" '#FF0000'
    },
    {
        from: -10,
        to: -0.01,
        name: '跌',
        color: "#52B12C", // 綠色  "#52B12C"    '#00FF00'
    },
]);
  constructor() {
    super();
    this.label.set('熱力圖');
    //this.setChartOptions();
  }
  setSeries() {
    return [{data:this.itemList}];
  }
  override ngOnInit(): void {
    super.ngOnInit();
  }
  async refresh() {
    //await this.getData(this.groupList, this.date);
    await this.getItemList(this.item,this.date);
    this.setChartOptions();
  }
  setChartOptions() {
    this.chartOptions = {
      series: this.setSeries(),
      chart: {
        height: this.height(),
        type: this.type(),
      },
      plotOptions: {
        // heatmap: {
        //   shadeIntensity: 0.5,
        //   colorScale: {
        //     ranges: this.ranges,
        //   },
        // },
        treemap: {
          enableShades: true,
          shadeIntensity: 0.5,
          reverseNegativeShade: true,
          colorScale: {
            ranges: this.ranges(),
          },
        },
      },
      dataLabels: {
        enabled: true,
      },
      title: {
        text: this.label(),
      },
    };
  }
  async getItemList(group:string,date:string){
    this.itemList = [];
    if(group === '') return;
    if(date === '') return;
    let sqlSelect = `select ME002,MF002,MA002,LG023,LG022,Round((CASE LG011 WHEN 0 THEN 0 ELSE (LG010-LG011)/LG011 END )*100,3) as pricePercent
      from STKME
      LEFT JOIN STKMF ON MF001=ME001
      LEFT JOIN STKMA ON MA001=MF002
      LEFT JOIN STKLG ON LG002='日線' AND LG004=MF002
      WHERE LG022 IS NOT NULL AND LG001='${date}' AND MF001='${group}'
      order by MF002 `;
    let sqlOrder = ` order by MF002`;
    let res: any[] = await this.jkBDb.simpleSql(sqlSelect);
    if (res.length === 0) return;
    this.label.set(res[0].ME002);
    for (let j = 0; j < res.length; j++) {
      let y = res[j].pricePercent;
      if(true){
        let item = { x: res[j].MA002, y: y }; // , value: res[j].LG006
        this.itemList.push(item);
      }else{
        console.log('pricePercent is null');
      }
    }
  this.setChartOptions(); //this.chartOptions.series = this.setSeries();

  }
  async getData(groupList: string[], date: string) {
    this.itemList = [];
    if (groupList.length === 0) return;
    if (date === '') return;
    let sqlSelect = `select ME002,MF002,MA002,LG023,LG022,Round((CASE LG011 WHEN 0 THEN 0 ELSE (LG010-LG011)/LG011 END )*100,3) as pricePercent
from STKME
LEFT JOIN STKMF ON MF001=ME001
LEFT JOIN STKMA ON MA001=MF002
LEFT JOIN STKLG ON LG002='日線' AND LG004=MF002
WHERE LG022 IS NOT NULL AND LG001='${date}'
 `;
    //sqlSelect = jkLib.array2Where(groupList,sqlSelect,'MF001');
    let sqlOrder = ` order by MF002`;
    for (let i = 0; i < groupList.length; i++) {
      let subGroupList: any[] = [];
      let ME002 = '';
      let sql = sqlSelect + ` AND MF001='${groupList[i]}' ` + sqlOrder;
      /*orm.query(sql).subscribe((res: any[]) => {
        if (res.length === 0) return;
        ME002 = res[0].ME002;
        for (let j = 0; j < res.length; j++) {
          let item = { x: res[j].MA002, y: res[j].pricePercent }; // , value: res[j].LG006
          subGroupList.push(item);
        }
        let subItem = { name: ME002, data: subGroupList };
        this.itemList.push(subItem);
        if (i === groupList.length - 1) {
          this.setChartOptions(); //this.chartOptions.series = this.setSeries();
        }
      });*/
      let res: any[] = await this.jkBDb.simpleSql(sql);
      if (res.length === 0) continue;
      ME002 = res[0].ME002;
      for (let j = 0; j < res.length; j++) {
        let y = res[j].pricePercent;
        if(true){
          let item = { x: res[j].MA002, y: y }; // , value: res[j].LG006
          subGroupList.push(item);
        }else{
          console.log('pricePercent is null');
        }
      }
      let subItem = { name: ME002, data: subGroupList };
      this.itemList.push(subItem);

    } // for i
    this.setChartOptions(); //this.chartOptions.series = this.setSeries();
  //this.chartOptions.series = this.setSeries(); // [{ data: this.candleList }]; // this.series2;
    //this.chartOptions.chart.animations = this.setAnimations();
    //this.chartOptions.title = this.getTitle();
    return;
  }
}
/* ranges [
              {
                from: -30,
                to: 5,
                name: "low",
                color: "#00A100"
              },
              {
                from: 6,
                to: 20,
                name: "medium",
                color: "#128FD9"
              },
              {
                from: 21,
                to: 45,
                name: "high",
                color: "#FFB200"
              },
              {
                from: 46,
                to: 55,
                name: "extreme",
                color: "#FF0000"
              }
            ]

  public generateData(count: number, yrange: any) {
    var i = 0;
    var series = [];
    while (i < count) {
      var x = 'w' + (i + 1).toString();
      var y =
        Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

      series.push({
        x: x,
        y: y,
      });
      i++;
    }
    return series;
  }
  seriesSample = [
    {
      name: 'Jan',
      data: this.generateData(20, {
        min: -30,
        max: 55,
      }),
    },
    {
      name: 'Feb',
      data: this.generateData(20, {
        min: -30,
        max: 55,
      }),
    },
    {
      name: 'Mar',
      data: this.generateData(20, {
        min: -30,
        max: 55,
      }),
    },
    {
      name: 'Apr',
      data: this.generateData(20, {
        min: -30,
        max: 55,
      }),
    },
    {
      name: 'May',
      data: this.generateData(20, {
        min: -30,
        max: 55,
      }),
    },
    {
      name: 'Jun',
      data: this.generateData(20, {
        min: -30,
        max: 55,
      }),
    },
    {
      name: 'Jul',
      data: this.generateData(20, {
        min: -30,
        max: 55,
      }),
    },
    {
      name: 'Aug',
      data: this.generateData(20, {
        min: -30,
        max: 55,
      }),
    },
    {
      name: 'Sep',
      data: this.generateData(20, {
        min: -30,
        max: 55,
      }),
    },
  ];
            */
